/**
 * Suunto X (Twitter) Pixel - APAC 转化追踪
 * Pixel ID: reo81
 * Events: PageView tw-reo81-rex81, AddToCart tw-reo81-rex8b, BeginCheckout tw-reo81-rg0dx, Purchase tw-reo81-rex8h
 * 注：payment_info_submitted (tw-reo81-rg02f) 发生在结账域内，主题拿不到，需走 Customer Events 自定义像素
 * 门控：复用 window.SuuntoConsent.shouldLoadAdvertisingStack() (OneTrust C0002/C0004 或 Shopify 隐私 API)
 * 未同意前轮询，同意后立即加载 https://static.ads-twitter.com/uwt.js 并触发事件。
 * 严格遵循 https://business.x.com/zh-cn/help/campaign-measurement-and-analytics/conversion-tracking-for-websites
 */
(function () {
  'use strict';
  var PIXEL_ID = 'reo81';
  var EVENTS = {
    pageview: 'tw-reo81-rex81',
    addToCart: 'tw-reo81-rex8b',
    beginCheckout: 'tw-reo81-rg0dx',
    purchase: 'tw-reo81-rex8h'
  };
  var baseLoaded = false;
  var pageviewFired = false;
  var beginCheckoutFired = false;
  var lastAddAt = 0;
  var cartCache = null;

  function designModeBypass() {
    return window.Shopify && window.Shopify.designMode;
  }

  function shouldLoad() {
    if (designModeBypass()) return true;
    if (window.SuuntoConsent && typeof window.SuuntoConsent.shouldLoadAdvertisingStack === 'function') {
      try {
        return window.SuuntoConsent.shouldLoadAdvertisingStack();
      } catch (e) {
        return false;
      }
    }
    // 主题当前未接入 consent-gated-tracking.js 时视为已授权，回退到直接加载，避免在 suunto-us 等未启用 OneTrust 时静默丢事件
    // 如需强制仅同意后才触发，请将下行改为 return false 并接入 SuuntoConsent
    return true;
  }

  function loadBase(callback) {
    if (baseLoaded) {
      if (callback) callback();
      return;
    }
    if (typeof window.twq !== 'function') {
      (function (e, t, n, s, u, a) {
        e.twq ||
          (s = e.twq = function () {
            s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
          }),
          (s.version = '1.1'),
          (s.queue = []),
          (u = t.createElement(n)),
          (u.async = true),
          (u.src = 'https://static.ads-twitter.com/uwt.js'),
          (a = t.getElementsByTagName(n)[0]),
          a.parentNode.insertBefore(u, a);
      })(window, document, 'script');
    }
    try {
      window.twq('config', PIXEL_ID);
    } catch (e) {}
    baseLoaded = true;
    window.dispatchEvent(new CustomEvent('suunto:x-ready'));
    if (callback) callback();
  }

  function getEmailPhone() {
    var email = null;
    var phone = null;
    try {
      var fm = window.FreshMarketerSourceMap && window.FreshMarketerSourceMap.currentCustomer;
      if (fm) {
        email = fm.email || null;
        phone = fm.mobile || null;
      }
      var el = document.getElementById('suunto-x-data');
      if (el && el.textContent) {
        var d = JSON.parse(el.textContent);
        if (!email && d.email) email = d.email;
        if (!phone && d.phone) phone = d.phone;
      }
    } catch (e) {}
    return { email: email, phone: phone };
  }

  function getCurrency() {
    try {
      if (
        window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.cartCurrency
      ) {
        return window.themeVariables.settings.cartCurrency;
      }
      var el = document.getElementById('suunto-x-data');
      if (el && el.textContent) {
        var d = JSON.parse(el.textContent);
        if (d.currency) return d.currency;
        if (d.cartCurrency) return d.cartCurrency;
      }
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) {}
    return 'USD';
  }

  function fire(eventId, params) {
    if (typeof window.twq !== 'function') return;
    try {
      window.twq('event', eventId, params || {});
    } catch (e) {}
  }

  function firePageView() {
    if (pageviewFired) return;
    pageviewFired = true;
    var ep = getEmailPhone();
    var params = {};
    try {
      var el = document.getElementById('suunto-x-data');
      if (el && el.textContent) {
        var d = JSON.parse(el.textContent);
        if (d.product) {
          params.contents = [
            {
              content_type: d.product.handle || null,
              content_id: d.product.sku || String(d.product.variantId || ''),
              content_name: d.product.title || null,
              content_price: d.product.price != null ? parseFloat(d.product.price) : null,
              num_items: 1,
              content_group_id: String(d.product.id || '')
            }
          ];
          if (d.product.price != null) {
            params.value = parseFloat(d.product.price);
            params.currency = getCurrency();
          }
        }
      }
    } catch (e) {}
    if (ep.email) params.email_address = ep.email;
    if (ep.phone) params.phone_number = ep.phone;
    // 补齐官方要求的其余可空字段，避免 X 像素助手报警告
    if (params.value == null) params.value = null;
    if (!params.currency) params.currency = null;
    if (!params.contents) params.contents = null;
    if (!params.conversion_id) params.conversion_id = null;
    if (!params.email_address) params.email_address = null;
    if (!params.phone_number) params.phone_number = null;
    fire(EVENTS.pageview, params);
  }

  function normalizePrice(raw) {
    if (raw == null) return null;
    if (typeof raw === 'number') return raw > 1000 ? raw / 100 : raw;
    var n = parseFloat(raw);
    return isNaN(n) ? null : n;
  }

  function fireAddToCart(detail) {
    if (Date.now() - lastAddAt < 800) return;
    lastAddAt = Date.now();
    var currency = getCurrency();
    var ep = getEmailPhone();
    var value = null;
    var contents = [];
    try {
      if (detail && detail.variant) {
        var v = detail.variant;
        var price = null;
        if (v.price != null) price = v.price / 100;
        else if (v.variant_price != null) price = parseFloat(v.variant_price);
        else if (v.presentment_price != null) price = parseFloat(v.presentment_price);
        else if (v.final_price != null) price = v.final_price / 100;
        var qty = v.quantity || 1;
        if (price != null) value = price * qty;
        contents.push({
          content_type: v.product_type || v.productType || null,
          content_id: v.sku || String(v.variant_id || v.id || ''),
          content_name: v.product_title || v.title || v.name || null,
          content_price: price,
          num_items: qty,
          content_group_id: v.product_id ? String(v.product_id) : null
        });
      } else if (detail && detail.items && detail.items.length) {
        var total = 0;
        detail.items.forEach(function (item) {
          var p = item.price != null ? item.price / 100 : null;
          if (p != null) total += p * (item.quantity || 1);
          contents.push({
            content_type: item.product_type || null,
            content_id: item.sku || String(item.variant_id || ''),
            content_name: item.product_title || item.title || null,
            content_price: p,
            num_items: item.quantity || 1,
            content_group_id: item.product_id ? String(item.product_id) : null
          });
        });
        if (total) value = total;
      }
    } catch (e) {}
    var params = {
      value: value,
      currency: currency,
      contents: contents.length ? contents : null,
      conversion_id: null,
      email_address: ep.email || null,
      phone_number: ep.phone || null
    };
    fire(EVENTS.addToCart, params);
  }

  function cacheCart() {
    if (!window.fetch) return;
    try {
      window
        .fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (json) {
          if (json) cartCache = json;
        })
        .catch(function () {});
    } catch (e) {}
  }

  function fireBeginCheckout() {
    if (beginCheckoutFired) return;
    if (!shouldLoad()) return;
    beginCheckoutFired = true;
    var currency = getCurrency();
    var ep = getEmailPhone();
    var value = null;
    var contents = [];
    if (cartCache && cartCache.items) {
      var total = 0;
      cartCache.items.forEach(function (it) {
        var p = it.price != null ? it.price / 100 : null;
        if (p != null) total += p * (it.quantity || 1);
        contents.push({
          content_type: it.product_type || null,
          content_id: it.sku || String(it.variant_id || it.id || ''),
          content_name: it.product_title || it.title || null,
          content_price: p,
          num_items: it.quantity || 1,
          content_group_id: it.product_id ? String(it.product_id) : null
        });
      });
      if (cartCache.total_price != null) value = cartCache.total_price / 100;
      else if (total) value = total;
      if (cartCache.currency) currency = cartCache.currency;
    }
    fire(EVENTS.beginCheckout, {
      value: value,
      currency: currency,
      contents: contents.length ? contents : null,
      status: 'started',
      conversion_id: null,
      email_address: ep.email || null,
      phone_number: ep.phone || null
    });
  }

  // 结账按钮：cart / mini-cart 均为 <button name="checkout"> + 表单提交
  // 加速结账（Shop Pay / PayPal / GPay）在 Shopify 的 iframe 内，此处捕获不到
  function attachCheckoutListeners() {
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('[name="checkout"], a[href*="/checkout"]')) fireBeginCheckout();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var f = e.target;
        if (!f || !f.querySelector) return;
        var action = (f.getAttribute && f.getAttribute('action')) || '';
        if (f.querySelector('[name="checkout"]') || action.indexOf('/checkout') !== -1) {
          fireBeginCheckout();
        }
      },
      true
    );
  }

  function firePurchase() {
    var data = null;
    try {
      if (window.__suuntoXCheckout && typeof window.__suuntoXCheckout === 'object') {
        data = window.__suuntoXCheckout;
      } else {
        var el = document.getElementById('suunto-x-checkout-data');
        if (el && el.textContent) data = JSON.parse(el.textContent);
      }
      // Shopify checkout/order 全局（order status / thank you 页由 Liquid 注入）
      if (!data && window.Shopify && window.Shopify.checkout) data = window.Shopify.checkout;
      if (!data) return;
      // 避免重复触发（同一 order 只发一次）
      var dedupKey = data.order_id || data.order_name || data.name || data.token || '';
      if (dedupKey && window.__suuntoXPurchaseFired === dedupKey) return;
      if (dedupKey) window.__suuntoXPurchaseFired = dedupKey;

      var currency = data.currency || data.presentment_currency || data.totalPriceSet && data.totalPriceSet.shopMoney && data.totalPriceSet.shopMoney.currencyCode || getCurrency();
      var total = null;
      if (data.total_price != null) total = data.total_price / 100;
      else if (data.totalPrice != null) total = parseFloat(data.totalPrice);
      else if (data.total_price_set && data.total_price_set.shop_money) total = parseFloat(data.total_price_set.shop_money.amount);
      else if (data.totalPriceSet && data.totalPriceSet.shopMoney) total = parseFloat(data.totalPriceSet.shopMoney.amount);

      var ep = getEmailPhone();
      var email = ep.email || data.email || data.customer_email || null;
      var phone = ep.phone || data.phone || data.billing_address && data.billing_address.phone || null;

      var items = data.line_items || data.lineItems || data.items || [];
      var contents = [];
      items.forEach(function (it) {
        var p = null;
        if (it.price != null) p = it.price / 100;
        else if (it.variant_price != null) p = parseFloat(it.variant_price);
        else if (it.price_set && it.price_set.shop_money) p = parseFloat(it.price_set.shop_money.amount);
        contents.push({
          content_type: it.product_type || null,
          content_id: it.sku || String(it.variant_id || it.product_id || ''),
          content_name: it.title || it.name || it.product_title || null,
          content_price: p,
          num_items: it.quantity || 1,
          content_group_id: it.product_id ? String(it.product_id) : null
        });
      });

      var conversionId = null;
      if (data.order_id) conversionId = String(data.order_id);
      else if (data.order_name) conversionId = String(data.order_name);
      else if (data.name) conversionId = String(data.name);
      else if (data.token) conversionId = String(data.token);
      else if (dedupKey) conversionId = String(dedupKey);

      var params = {
        value: total,
        currency: currency,
        contents: contents.length ? contents : null,
        conversion_id: conversionId,
        email_address: email,
        phone_number: phone
      };
      fire(EVENTS.purchase, params);
    } catch (e) {}
  }

  function attachAddToCartListeners() {
    document.addEventListener('variant:added', function (e) {
      if (!shouldLoad()) return;
      var v = e.detail && e.detail.variant ? e.detail.variant : null;
      if (v) fireAddToCart({ variant: v });
    });

    // 拦截 fetch /cart/add* 兼容 quick-buy / cart-drawer-open-button
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = '';
        try {
          url = typeof input === 'string' ? input : (input && input.url) || '';
        } catch (e) {}
        var isAdd = url.indexOf('/cart/add') !== -1;
        var p = origFetch.apply(this, arguments);
        if (isAdd) {
          p.then(function (res) {
            try {
              if (!res.ok) return res;
              var clone = res.clone();
              clone
                .json()
                .then(function (json) {
                  if (!shouldLoad()) return;
                  var variant = null;
                  if (json.items && json.items.length) variant = json.items[0];
                  else if (json.key || json.variant_id || json.id) variant = json;
                  else if (json.product_id) variant = json;
                  if (variant) fireAddToCart({ variant: variant });
                })
                .catch(function () {});
            } catch (e) {}
            return res;
          }).catch(function () {});
        }
        return p;
      };
    }
  }

  function init() {
    attachAddToCartListeners();
    attachCheckoutListeners();
    cacheCart();

    if (!shouldLoad()) {
      var tries = 0;
      var timer = setInterval(function () {
        if (shouldLoad()) {
          clearInterval(timer);
          loadBase(function () {
            firePageView();
            firePurchase();
          });
        }
        if (++tries > 360) clearInterval(timer);
      }, 500);
      document.addEventListener('OneTrustGroupsUpdated', function () {
        if (shouldLoad()) loadBase(function () { firePageView(); firePurchase(); });
      });
      document.addEventListener('OTConsentApplied', function () {
        if (shouldLoad()) loadBase(function () { firePageView(); firePurchase(); });
      });
      document.addEventListener('trackingConsentAccepted', function () {
        if (shouldLoad()) loadBase(function () { firePageView(); firePurchase(); });
      });
      document.addEventListener('visitorConsentCollected', function () {
        if (shouldLoad()) loadBase(function () { firePageView(); firePurchase(); });
      });
      window.addEventListener('suunto:deferred-tracking-ready', function () {
        if (shouldLoad() && baseLoaded) firePageView();
        if (shouldLoad() && !baseLoaded) loadBase(function(){ firePageView(); });
      });
      return;
    }

    loadBase(function () {
      firePageView();
      firePurchase();
    });
  }

  window.SuuntoXPixel = {
    firePageView: firePageView,
    fireAddToCart: fireAddToCart,
    fireBeginCheckout: fireBeginCheckout,
    firePurchase: firePurchase,
    init: init,
    PIXEL_ID: PIXEL_ID,
    EVENTS: EVENTS
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('suunto:deferred-tracking-ready', function () {
    if (!pageviewFired && shouldLoad() && baseLoaded) firePageView();
  });
})();
